import VerifyContainer from './VerifyContainer';
export default VerifyContainer;
